import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_MANUFACTURERS_SHOP_REQUEST = "API_MANUFACTURERS_SHOP_REQUEST";
export const API_MANUFACTURERS_SHOP_SUCCESS = "API_MANUFACTURERS_SHOP_SUCCESS";
export const API_MANUFACTURERS_SHOP_FAILURE = "API_MANUFACTURERS_SHOP_FAILURE";

export const api_manufacturers_shop_request = (options) => {
	return {
		type: API_MANUFACTURERS_SHOP_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_manufacturers_shop_success = (data) => {
	return {
		type: API_MANUFACTURERS_SHOP_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_manufacturers_shop_failure = (error) => {
	return {
		type: API_MANUFACTURERS_SHOP_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Manufacturers.apiManufacturersShop
*/
export const apiManufacturersShop = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_manufacturers_shop_request(options));
			const url=getAPIUrl([
				{"url": "/api/manufacturers/shop", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_manufacturers_shop_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_manufacturers_shop_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
